export default __webpack_public_path__ + "static/media/DOLL_P4.3dea52fe.svg";